import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, of, tap } from 'rxjs';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { PdaPlaceholders } from '../placeholder';
import { environment } from 'src/environments/environment';
import { PdaConfigurationService } from './pda-config.service';

@Injectable({
  providedIn: 'root'
})
export class PdaAuthService {
  private _logout = new BehaviorSubject<boolean>(false);
  logout = this._logout.asObservable();
  private _isLogged = new BehaviorSubject<boolean>(false);
  isLogged = this._isLogged.asObservable();
  constructor(private http: HttpClient,
    private pdaConfig: PdaConfigurationService
  ) { }

  /**
   * @GET
   * Logs user into PDA
   * @returns a token
   */
  loginToPda():Observable<PdaAccessToken> {
    return this.http.get<PdaAccessToken>(this.pdaConfig.getBaseUrl() + this.pdaConfig.getAuthUrl());
    // return of<PdaAccessToken>(
    //   {
    //     "type": "Simple",
    //     "user": "faaa3d57-c72b-46c0-a660-c48e80757b91",
    //     "passwd": "29cccd5e-528b-46b4-b3c0-d970329f0f53",
    //     "expiresIn": 28800,
    //     "refreshToken": "e39e7eea-4ee2-4028-bac4-260223db5e63",
    //     "refreshTokenExpiresIn": 29400
    //   }
    // )
  }

  /**
   * @POST
   * Saves PDA Token
   * @returns the saved token
   */
  saveUserToken(body):Observable<PdaSaveTokenRequest>  {
    return this.http.post<PdaAccessToken>( ServicePathsSettings.URL_PDA_AUTH, body);
  }

  /**
   * @GET
   * Gets an updated token
   * @returns a new refreshed token
  */
  getUserToken():Observable<PdaAccessToken>  {
    return this.http.get<PdaAccessToken>(ServicePathsSettings.URL_PDA_AUTH);
  }

  /**
   * @DELETE
   * Deletes token and log User out
   */
  deleteUserToken(): Observable<string>{
    return this.http.delete(ServicePathsSettings.URL_PDA_AUTH,{responseType: 'text'}).pipe(
      map(res => res.toString())
    )
  }

  onLogoutUserPda(val) {
    this._logout.next(val);
  }

  setIsLogged(val: boolean) {
    this._isLogged.next(val);
  }

  async isUserLoggedToPda():Promise<boolean> {
    let token = await this.getPdaToken();
    return !!token;
  }

  //PDA TOKEN

  //pda token = session storage, single session, removed when browser is closed
  //pda infos = local storage, multiple session, token has been saved
  async getPdaToken(): Promise<PdaAccessToken> {
    let token = await localStorage.getItem(PdaPlaceholders.pda_token);
    return JSON.parse(token);
  }

  async setPdaToken(pdaToken: any): Promise<void> {
    return localStorage.setItem(PdaPlaceholders.pda_token, JSON.stringify(pdaToken));
  }

  async removePdaToken(): Promise<void> {
    return localStorage.removeItem(PdaPlaceholders.pda_token);
  }

  //PDA INFOS

  async getPdaInfos(): Promise<PdaAcceptanceInfos> {
    let infos = await localStorage.getItem(PdaPlaceholders.pda_infos);
    return JSON.parse(infos);
  }

  async setPdaInfos(pdaInfos: any): Promise<void> {
    return localStorage.setItem(PdaPlaceholders.pda_infos, JSON.stringify(pdaInfos));
  }

  async removePdaInfos(): Promise<void> {
    return localStorage.removeItem(PdaPlaceholders.pda_infos);
  }

}

export interface PdaAccessToken {
  type: string;
  user: string;
  password?: string;
  passwd?: string;
  expiresIn: number;
  refreshToken: string;
  refreshTokenExpiresIn: number;
}


export interface PdaAcceptanceInfos{
  acceptanceFlag?: boolean;
  acceptanceTimestamp?: number;
}

export interface PdaSaveTokenRequest extends PdaAccessToken, PdaAcceptanceInfos {

}